import layout from '../layout.vue';
const _import = (file) => import(`./pages/${file}.vue`)

export default {
    path: '/etc/',
    component:layout,
    children:[
		{name: '数据统计', path: 'index', component: ()=>_import('index')},
		{name: '协议列表', path: 'order', component: ()=>_import('order')},
		{name: '下载列表', path: 'download', component: ()=>_import('download')},
        // add route here
    ]
}